const captureLink = function(url, tag) {
    window.gtag('event', tag, { 'send_to': url });
    window.location = url;
}

export { captureLink }
